'use client'

import React from 'react'

type Props = {
    semiAxisA: number
    semiAxisB: number
}

const WIDTH = 340
const HEIGHT = 220

export default function EllipseChart({ semiAxisA, semiAxisB }: Props) {
    const maxDim = Math.max(semiAxisA, semiAxisB, 0.0001)
    const scale = 90 / maxDim
    const rx = Math.max(semiAxisA * scale, 20)
    const ry = Math.max(semiAxisB * scale, 20)

    const cx = WIDTH / 2
    const cy = HEIGHT / 2

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <ellipse cx={cx} cy={cy} rx={rx} ry={ry} fill="#2563eb" opacity={0.15} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx} y1={cy} x2={cx + rx} y2={cy} stroke="#2563eb" strokeWidth={1.5} />
            <line x1={cx} y1={cy} x2={cx} y2={cy - ry} stroke="#2563eb" strokeWidth={1.5} />
            <circle cx={cx} cy={cy} r={2.5} fill="#2563eb" />
            <text x={cx + rx / 2} y={cy - 8} fontSize={12} textAnchor="middle" fill="#374151">a = {semiAxisA.toFixed(2)}</text>
            <text x={cx + 10} y={cy - ry / 2} fontSize={12} textAnchor="start" fill="#374151">b = {semiAxisB.toFixed(2)}</text>
        </svg>
    )
}
